import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";

/** Hero search box that hands off to the /search page. */
export function HomeSearchBox() {
  const navigate = useNavigate();
  const [term, setTerm] = useState("");

  return (
    <form
      className="mt-8 flex max-w-2xl mx-auto gap-2 rounded-2xl border border-border bg-card p-2 shadow-lift"
      onSubmit={(e) => {
        e.preventDefault();
        navigate({
          to: "/search",
          search: { q: term, make: "", model: "", year: undefined, type: "", page: 1 },
        });
      }}
    >
      <label htmlFor="home-search" className="sr-only">
        Search vehicles by make or model
      </label>
      <div className="relative flex-1">
        <svg
          aria-hidden="true"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" />
        </svg>
        <input
          id="home-search"
          type="search"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Search any make or model — e.g. “toyota tacoma”"
          className="h-12 w-full rounded-xl bg-transparent py-3.5 pl-11 pr-3 text-base text-foreground placeholder:text-muted-foreground focus:outline-none"
        />
      </div>
      <button
        type="submit"
        className="shrink-0 cta-gold px-6 py-3.5 shadow-soft"
      >
        Search
      </button>
    </form>
  );
}
